"use client";

import cnBind from "classnames/bind";
import { AnimatePresence, motion, useReducedMotion } from "motion/react";
import type { CSSProperties } from "react";

import { ModalCallBack } from "@/components/_Modals/ModalCallBack";
import { useOnboardModal } from "@/shared/hooks/useOnboardModal";
import { toLeadIndustryPreset } from "@/shared/utils/toLeadIndustryPreset";

import { useIndustryPreset } from "./IndustryPresetContext";

import styles from "./IndustryKpis.module.scss";

const cx = cnBind.bind(styles);

/** Big numbers grid — scanable proof, almost no prose. */
export const IndustryKpis = () => {
    const reduceMotion = useReducedMotion();
    const { activePreset, preset } = useIndustryPreset();
    const { isModalOpen, leadIntent, openSaasModal, closeModal } = useOnboardModal();

    const openTrial = () => {
        openSaasModal("demo", "Demo", {
            industryPreset: toLeadIndustryPreset(activePreset),
            leadSource: `homepage_kpis_${activePreset}`,
        });
    };

    return (
        <section
            className={cx("section")}
            style={
                {
                    ["--preset-accent" as string]: preset.accent,
                    ["--preset-accent-soft" as string]: preset.accentSoft,
                } as CSSProperties
            }
        >
            <div className={cx("wrapper", "container")}>
                <AnimatePresence mode="wait">
                    <motion.div
                        key={activePreset}
                        initial={reduceMotion ? false : { opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={reduceMotion ? undefined : { opacity: 0 }}
                        transition={{ duration: 0.22 }}
                    >
                        <div className={cx("grid")}>
                            {preset.kpis.map((kpi) => (
                                <article key={kpi.label} className={cx("kpi")}>
                                    <strong>{kpi.value}</strong>
                                    <p>{kpi.label}</p>
                                </article>
                            ))}
                        </div>

                        <div className={cx("ctaWrap")}>
                            <button type="button" className={cx("cta")} onClick={openTrial}>
                                Начать с Tezam · {preset.shortLabel}
                            </button>
                        </div>
                    </motion.div>
                </AnimatePresence>
            </div>

            <ModalCallBack isOpen={isModalOpen} onClose={closeModal} leadIntent={leadIntent} />
        </section>
    );
};
